import React from "react";
import { connect } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";

import { userActions } from "../../_actions";
import { FormDatosUsuario } from "../perfil/FormDatosUsuario";
import { PanelSeguridad } from "../perfil/PanelSeguridad";
import { NavBarLateral } from "./NavBarLateral";

class MiPerfilComprador extends React.Component {
  handleClose = () => {};

  render() {
    return (
      <div className="dashboard">
        <NavBarLateral handleClose={this.handleClose} />
        <div className="dashboard__content">
          <div className="dashboard__content-header">
            <div className="dashboard__content-title">
              <h2>Mi perfil</h2>
            </div>
          </div>
          <div className="dashboard__content-subheader">
            <h3 className="small">
              Acá podés cambiar tus datos personales y de ubicación.
            </h3>
          </div>

          {/*
            La ubicación va en su propia solapa, igual que en el perfil del vendedor
            (ahí vive dentro de "Mi tienda", que el comprador no tiene). Es la dirección
            con la que se despachan sus compras, asi que tiene que seguir siendo
            editable: es un solo formulario y "Grabar cambios" guarda las dos solapas.
          */}
          <FormDatosUsuario
            className="bg-iot"
            accion="actualizar"
            esVendedor={false}
          >
            {({ secciones, botonGrabar }) => (
              /* mountOnEnter: el form de datos pide provincias al montarse, no hace
                 falta que eso pase si la persona solo viene a cambiar la clave. */
              <Tabs id="perfil-comprador-tabs" defaultActiveKey="datos" mountOnEnter>
                <Tab eventKey="datos" title="Mis datos">
                  <div className="perfil__panel">
                    {secciones.datosUsuario}
                    {secciones.perfil}
                    {secciones.redes}
                    {secciones.imagenes}
                    {botonGrabar}
                  </div>
                </Tab>
                <Tab eventKey="ubicacion" title="Ubicación">
                  <div className="perfil__panel">
                    {secciones.ubicacion}
                    {botonGrabar}
                  </div>
                </Tab>
                <Tab eventKey="seguridad" title="Seguridad">
                  <div className="perfil__panel">
                    <PanelSeguridad />
                  </div>
                </Tab>
              </Tabs>
            )}
          </FormDatosUsuario>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {
  traerMiPerfil: userActions.traerMiPerfil,
};

const connectedMiPerfilComprador = connect(
  mapState,
  actionCreators
)(MiPerfilComprador);
export { connectedMiPerfilComprador as MiPerfilComprador };
